<template>
  <el-dialog
    :title="modalTitle"
    :visible="visible"
    class="responsive"
    width="800px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <ValidationObserver ref="form" v-slot="{ handleSubmit, invalid }">
      <form class="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Tên mặt hàng <span class="text-danger">*</span></label>
              <ValidationProvider vid="name" name="Tên mặt hàng" rules="required" v-slot="{ errors, classes }">
                <el-input
                  v-model="form.name"
                  placeholder="Nhập tên mặt hàng"
                  class="w-100"
                  :class="classes"
                  clearable
                />
                <div class="fv-plugins-message-container">
                  <div class="fv-help-block text-danger">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Giá <span class="text-danger">*</span></label>
              <ValidationProvider
                vid="price"
                name="Giá"
                rules="required|min_value:1|max_value:100000000"
                v-slot="{ errors, classes }"
              >
                <money
                  v-model="form.price"
                  v-bind="money"
                  placeholder="Nhập giá"
                  class="form-control text-right w-100"
                  :class="showPriceValidation ? classes : ''"
                  @keydown.native="onPriceInteract"
                  @paste.native="onPriceInteract"
                  @blur.native="onPriceBlur"
                />
                <div v-if="showPriceValidation" class="fv-plugins-message-container">
                  <div class="fv-help-block text-danger">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Loại <span class="text-danger">*</span></label>
              <ValidationProvider vid="type" name="Loại" rules="required" v-slot="{ errors, classes }">
                <el-select
                  v-model="form.type"
                  placeholder="Chọn loại"
                  class="w-100"
                  :class="classes"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
                <div class="fv-plugins-message-container">
                  <div class="fv-help-block text-danger">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Phân loại chi tiết <span class="text-danger">*</span></label>
              <ValidationProvider
                vid="type_detail"
                name="Phân loại chi tiết"
                rules="required"
                v-slot="{ errors, classes }"
              >
                <el-select
                  v-model="form.type_detail"
                  placeholder="Chọn phân loại chi tiết"
                  class="w-100"
                  :class="classes"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in typeDetailOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
                <div class="fv-plugins-message-container">
                  <div class="fv-help-block text-danger">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Barcode <span class="text-danger">*</span></label>
              <ValidationProvider
                vid="barcode"
                name="Barcode"
                rules="required|barcode_format"
                v-slot="{ errors, classes }"
              >
                <el-input
                  v-model="form.barcode"
                  placeholder="Nhập barcode"
                  class="w-100"
                  :class="classes"
                  clearable
                  @input="handleBarcodeInput"
                />
                <div class="fv-plugins-message-container">
                  <div class="fv-help-block text-danger">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Số lượng báo động <span class="text-danger">*</span></label>
              <ValidationProvider
                vid="reorder_level"
                name="Số lượng báo động"
                rules="required|integer|min_value:0"
                v-slot="{ errors, classes }"
              >
                <el-input
                  v-model="form.reorder_level"
                  type="number"
                  min="0"
                  step="1"
                  placeholder="Nhập số lượng báo động"
                  class="w-100"
                  :class="classes"
                  clearable
                />
                <div class="fv-plugins-message-container">
                  <div class="fv-help-block text-danger">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Mô tả</label>
              <el-input
                v-model="form.description"
                type="textarea"
                :rows="3"
                placeholder="Nhập mô tả"
                class="w-100"
              />
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Trạng thái <span class="text-danger">*</span></label>
              <ValidationProvider
                vid="logistic_product_status"
                name="Trạng thái"
                rules="required"
                v-slot="{ errors, classes }"
              >
                <el-select
                  v-model="form.logistic_product_status"
                  placeholder="Chọn trạng thái"
                  class="w-100"
                  :class="classes"
                >
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <div class="fv-plugins-message-container">
                  <div class="fv-help-block text-danger">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <footer class="d-flex justify-content-end pt-4">
          <button
            type="button"
            class="btn btn-secondary font-weight-bold mr-2"
            :disabled="submitting"
            @click="handleClose"
          >
            Đóng
          </button>
          <button type="submit" class="btn btn-primary font-weight-bold" :disabled="invalid || submitting">
            <i v-if="submitting" class="fas fa-spinner fa-spin mr-1"></i>
            {{ submitting ? "Đang lưu..." : submitButtonText }}
          </button>
        </footer>
      </form>
    </ValidationObserver>
  </el-dialog>
</template>

<script>
import { Money } from "v-money";
import {
  PRODUCT_STATUS_OPTIONS,
  PRODUCT_TYPE_DETAIL_OPTIONS,
  PRODUCT_TYPE_OPTIONS,
} from "@/core/option/logisticsOption";

export default {
  name: "ProductFormModal",
  components: {
    Money,
  },
  props: {
    mode: {
      type: String,
      required: true,
      validator: (v) => ["create", "edit"].includes(v),
    },
    initialData: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    submitHandler: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      form: this.getInitialForm(),
      submitting: false,
      submitAttempted: false,
      priceTouched: false,
      typeOptions: PRODUCT_TYPE_OPTIONS,
      typeDetailOptions: PRODUCT_TYPE_DETAIL_OPTIONS,
      statusOptions: PRODUCT_STATUS_OPTIONS,
      money: {
        decimal: ",",
        thousands: ",",
        prefix: "",
        suffix: " đ",
        precision: 0,
        masked: false,
      },
    };
  },
  computed: {
    showPriceValidation() {
      return this.submitAttempted || this.priceTouched;
    },
    modalTitle() {
      return this.mode === "create" ? "Tạo mới mặt hàng" : "Sửa mặt hàng";
    },
    submitButtonText() {
      return this.mode === "create" ? "Thêm mới" : "Cập nhật";
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.syncFormFromProps();
      }
    },
    initialData: {
      handler(val) {
        if (this.visible && val) {
          this.syncFormFromProps();
        }
      },
      deep: true,
    },
  },
  methods: {
    getInitialForm() {
      return {
        name: "",
        price: "",
        type: null,
        type_detail: null,
        description: "",
        logistic_product_status: 0,
        barcode: "",
        reorder_level: "",
      };
    },
    toNumberOrDefault(value, defaultValue = null) {
      return [null, undefined, ""].includes(value) ? defaultValue : Number(value);
    },
    getFormNumber(field, defaultValue = null) {
      const initialValue = this.mode === "edit" ? this.initialData?.[field] : defaultValue;
      return this.toNumberOrDefault(
        this.form[field],
        this.toNumberOrDefault(initialValue, defaultValue)
      );
    },
    syncFormFromProps() {
      this.submitAttempted = false;
      this.priceTouched = false;
      if (this.mode === "edit" && this.initialData) {
        this.form = {
          name: this.initialData.name || "",
          price: this.initialData.price ?? "",
          type: this.toNumberOrDefault(this.initialData.type),
          type_detail: this.toNumberOrDefault(this.initialData.type_detail),
          description: this.initialData.description || "",
          logistic_product_status: this.toNumberOrDefault(
            this.initialData.logistic_product_status,
            0
          ),
          barcode: String(this.initialData.barcode ?? "").toUpperCase(),
          reorder_level: this.toNumberOrDefault(
            this.initialData.reorder_level,
            0
          ),
        };
      } else {
        this.form = this.getInitialForm();
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
        this.priceTouched = false;
      });
    },
    onPriceInteract() {
      this.priceTouched = true;
    },
    onPriceBlur() {
      this.priceTouched = true;
      const normalizedPrice = Number(this.form.price) || 0;
      if (normalizedPrice > 100000000) {
        this.form.price = 100000000;
      }
    },
    handleBarcodeInput(value) {
      this.form.barcode = String(value || "").toUpperCase();
    },
    handleClose() {
      this.form = this.getInitialForm();
      this.submitting = false;
      this.submitAttempted = false;
      this.priceTouched = false;
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.$emit("close");
    },
    async onSubmit() {
      if (this.submitting) return;
      this.submitAttempted = true;
      this.submitting = true;

      const payload = {
        name: this.form.name.trim(),
        price: Math.min(Number(this.form.price) || 0, 100000000),
        type: this.getFormNumber("type"),
        type_detail: this.getFormNumber("type_detail"),
        description: (this.form.description || "").trim(),
        logistic_product_status: this.getFormNumber("logistic_product_status", 0),
        barcode: String(this.form.barcode ?? "").trim().toUpperCase(),
        reorder_level: this.getFormNumber("reorder_level", 0),
      };

      if (this.mode === "edit" && this.initialData?.id) {
        payload.id = this.initialData.id;
      }

      try {
        if (this.submitHandler && typeof this.submitHandler === "function") {
          await this.submitHandler(payload);
          this.$emit("submit", payload);
          this.handleClose();
        } else {
          this.$emit("submit", payload);
        }
      } catch (err) {
        const validationErrors =
          err?.data?.message_validate_form ||
          err?.data?.data?.message_validate_form ||
          err?.response?.data?.message_validate_form ||
          err?.response?.data?.data?.message_validate_form;

        if (validationErrors && this.$refs.form) {
          this.$refs.form.setErrors(validationErrors);
        }
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.fv-help-block {
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
</style>
